import React, { Component } from 'react';

import { MultiTextField } from 'lvd-fluentui-multitextfield';
import { propTypes } from 'react-bootstrap/esm/Image';

 export default class PatientName extends Component {


     constructor(props){
        super(props);

		this.state = {
			values: []
		};

		this._handleValuesChanged = 
			this._handleValuesChanged.bind(this);
	   }

         
    _handleValuesChanged(values) {
		// Do something with the values
		this.setState({
			values: values
		});

     
     }


  render() {
       
    return (
      <div>
        
          { <MultiTextField 
            placeholder="Patient Name"
       				values={this.state.values}
		      		onChange={this._handleValuesChanged}
              onSubmit={this.props.onSubmit}
             required={true}
            
			/>}
             
             <div className="row">
              <div className='col-md-6 col-6'>
              <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
               </div>

              <div className='col-md-6 col-6'>
                 <button type="submit" onClick={()=>this.props.onSubmit(this.state.values)}  className="btn btn-block submit-button btn-sm"> Submit</button>
              </div>
              </div>

      </div>
    );
  }



}
